var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-admin",
      attrs: {
        "active-text-color": "#3e10d5",
        "unique-opened": true,
        "default-active": _vm.active
      },
      on: { open: _vm.fetchAssignedApplications }
    },
    [
      _c(
        "div",
        [
          _vm._v("Οι αιτήσεις μου από\r\n    "),
          _vm._l(_vm.assignedApps, function(submenu, key) {
            return _c(
              "el-submenu",
              { key: submenu[0].id, attrs: { index: submenu[0].id } },
              [
                _c(
                  "template",
                  { slot: "title" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.translate(key)))]),
                    _vm._v(" "),
                    _c("el-badge", { attrs: { value: _vm.numberOfApps[key] } })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.mainApps, function(app) {
                  return _c(
                    "el-menu-item",
                    {
                      key: app.id,
                      staticClass: "list-group-item",
                      staticStyle: { padding: "0px 5px" },
                      attrs: { value: app.id, index: _vm.roleIndexId(app.id) },
                      on: {
                        click: function($event) {
                          _vm.toggleApplication(app)
                        }
                      }
                    },
                    [
                      _vm.showPopover
                        ? _c(
                            "div",
                            { staticClass: "text item" },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "hover",
                                    placement: "right"
                                  }
                                },
                                [
                                  _vm.activeLane == "presidentW_Prechecker"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n              Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ον/μο υπαλλήλου προελέγχου: " +
                                            _vm._s(app.precheckerSurname) +
                                            " " +
                                            _vm._s(app.precheckerName) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane == "viewerW_Proponent"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ον/μο εισηγητή: " +
                                            _vm._s(app.proponentSurname) +
                                            " " +
                                            _vm._s(app.proponentName) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane == "viewerW_Board"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Εκτ.Επιτροπή: " +
                                            _vm._s(app.executiveBoard) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane == "viewerW_Vice"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane == "presidentW_PrintDecision"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  [
                                    "printdecisionw_",
                                    "precheckerW_",
                                    "precheckerCompensatoryW_"
                                  ].includes(_vm.activeLane)
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n              Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(
                                              app.protocol
                                                ? app.protocol
                                                : "Θα οριστεί με την ολοκλήρωση του προελέγχου"
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\r\n              Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate
                                                ? app.protocolDate.substring(
                                                    0,
                                                    10
                                                  )
                                                : "Θα οριστεί με την ολοκλήρωση του προελέγχου"
                                            ) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  [
                                    "proponentW_President",
                                    "proponentW_Prechecker",
                                    "proponentW_Board",
                                    "proponentW_Admin",
                                    "presidentW_Consultant",
                                    "presidentW_Viewer",
                                    "presidentW_AcademicDirector",
                                    "presidentW_AcademicDirector_Reappraisal",
                                    "presidentW_ReappraisalBoard",
                                    "presidentW_AcademicDirector_fromProponent"
                                  ].includes(_vm.activeLane)
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n              Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  [
                                    "consultantW_proponent",
                                    "consultantw_President",
                                    "viewerW_President",
                                    "academicDirectorW_President",
                                    "proponentW_ReappraisalBoard",
                                    "academicDirectorW_ReappraisalBoard"
                                  ].includes(_vm.activeLane)
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Id αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane === "reappraisalBoardW_Vice"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Id αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Επιτροπή επανεξ:" +
                                            _vm._s(app.reappraisalBoardName) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane ===
                                  "reappraisalBoardW_President"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Id αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Επιτροπή επανεξ:" +
                                            _vm._s(app.reappraisalBoardName) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeLane ==
                                  "academicDirectorW_Proponent"
                                    ? _c("div", [
                                        _vm._v(
                                          "\r\n               Αρ. αίτησης: " +
                                            _vm._s(app.id) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Αρ. πρωτ.: " +
                                            _vm._s(app.protocol) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ημ/νια πρωτοκόλλου: " +
                                            _vm._s(
                                              app.protocolDate.substring(0, 10)
                                            ) +
                                            "\r\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "Ακαδ. περιοχή: " +
                                            _vm._s(app.academicArea) +
                                            "\r\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: _vm.calcStyle(app),
                                          attrs: { circle: "" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.calcDegreeType(
                                                app.degreeType,
                                                app.applicationType
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._v(
                                        "\r\n              " +
                                          _vm._s(
                                            app.dateCompleted
                                              ? app.dateCompleted.substring(
                                                  0,
                                                  10
                                                )
                                              : app.protocolDate
                                                ? app.protocolDate.substring(
                                                    0,
                                                    10
                                                  )
                                                : app.id
                                          ) +
                                          "\r\n              " +
                                          _vm._s(app.surname.substring(0, 18)) +
                                          "\r\n              " +
                                          _vm._s(app.name.substring(0, 1)) +
                                          ".\r\n            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.rolesToShow
        ? _c(
            "el-submenu",
            { key: "0", attrs: { index: "0" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c("span", [_vm._v("Αναμονή")]),
                  _vm._v(" "),
                  _c("el-badge", { attrs: { value: _vm.numberOfStashedApps } })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.stashedApps, function(app) {
                return _c(
                  "el-menu-item",
                  {
                    key: app.id,
                    staticClass: "list-group-item",
                    staticStyle: { padding: "0px 5px" },
                    attrs: { value: app.id, index: _vm.roleIndexId(app.id) },
                    on: {
                      click: function($event) {
                        _vm.toggleApplication(app)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "text item" }, [
                      _c(
                        "span",
                        [
                          _c(
                            "el-button",
                            {
                              style: _vm.calcStyle(app),
                              attrs: { circle: "" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.calcDegreeType(
                                    app.degreeType,
                                    app.applicationType
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(
                            "\r\n            " +
                              _vm._s(
                                app.dateCompleted
                                  ? app.dateCompleted.substring(0, 10)
                                  : app.protocolDate
                                    ? app.protocolDate.substring(0, 10)
                                    : app.id
                              ) +
                              "\r\n            " +
                              _vm._s(app.surname.substring(0, 18)) +
                              "\r\n            " +
                              _vm._s(app.name.substring(0, 1)) +
                              ".\r\n          "
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeRole != "AcademicConsultant" &&
      _vm.activeRole != "Auditor" &&
      _vm.activeRole != "SpecialReappraisalBoardMember"
        ? _c(
            "el-menu-item",
            { attrs: { index: "1000" }, on: { click: _vm.toggleSearch } },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v("Αναζήτηση Αιτήσεων")])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeRole != "AcademicConsultant" &&
      _vm.activeRole != "Auditor" &&
      _vm.activeRole != "SpecialReappraisalBoardMember"
        ? _c(
            "el-menu-item",
            { attrs: { index: "1001" }, on: { click: _vm.toggleUniSearch } },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v("Αναζήτηση Ιδρυμάτων")])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeRole == "SpecialProponent"
        ? _c(
            "el-menu-item",
            { attrs: { index: "1002" }, on: { click: _vm.addUniversity } },
            [_c("span", [_vm._v("Διαχειριστικό Ιδρυμάτων")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeRole == "President"
        ? _c(
            "el-menu-item",
            {
              attrs: { index: "1003" },
              on: { click: _vm.toggleConsultantsList }
            },
            [_c("span", [_vm._v("Στατιστικά αξιολογητών")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeRole == "PhdRegistry"
        ? _c(
            "el-menu-item",
            {
              attrs: { index: "1004" },
              on: { click: _vm.togglePhdRegistration }
            },
            [_c("span", [_vm._v("Καταχώριση Διδακτορικών στο ΕΑΔΔ")])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de533840", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de533840","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ApplicationsLane.vue
// module id = null
// module chunks = 